module.exports = __webpack_public_path__ + "static/media/Derek_Clegg_-_09_-_Youre_The_Dummy.3d8fffdc.mp3";